import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import { Section } from 'foundations-components/transitional/components/Section';
import { Flex } from 'foundations-components/components/Flex';
import { FILTER_PROPERTIES_ALLOW_LIST } from '../../constants/viewFilters';
import { useDispatch, useSelector } from '../../context/Redux';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { useTempFilters } from '../../hooks/useTempFilters';
import { resetTempViewFilters } from '../../redux/actions/tempViewState';
import { getHasNonDefaultFiltersSelector } from '../../redux/selectors/tempViewState';
import AssigneeFilter from './AssigneeFilter';
import DueDateFilter from './DueDateFilter';
import QueueFilter from './QueueFilter';
import QuickFilterContainer from './QuickFilterContainer';
import TaskTypeFilter from './TaskTypeFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function FilterHeaderBar({
  viewId,
  endSlot
}) {
  const dispatch = useDispatch();
  const getHasNonDefaultFilters = useSelector(getHasNonDefaultFiltersSelector);
  const hasNonDefaultFilters = getHasNonDefaultFilters(viewId);
  const crmSearchFilters = useTempFilters(viewId);
  const queryParamsString = useQueryParamString();
  const shouldShowHighlight = crmSearchFilters && crmSearchFilters.length > 0;
  const handleResetFilters = useCallback(() => {
    dispatch(resetTempViewFilters({
      viewId,
      propertyNames: FILTER_PROPERTIES_ALLOW_LIST
    }));
  }, [viewId, dispatch]);
  return /*#__PURE__*/_jsx(UIFilterBar, {
    flush: true,
    startSlot: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        display: "inline-flex",
        flexWrap: "wrap",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(AssigneeFilter, {
          viewId: viewId
        }), /*#__PURE__*/_jsx(TaskTypeFilter, {
          viewId: viewId
        }), /*#__PURE__*/_jsx(DueDateFilter, {
          viewId: viewId
        }), /*#__PURE__*/_jsx(QueueFilter, {
          viewId: viewId
        })]
      }), /*#__PURE__*/_jsx(QuickFilterContainer, {
        shouldHighlight: shouldShowHighlight,
        children: /*#__PURE__*/_jsxs(UIRouterButton, {
          "data-test-id": "more-filters-button",
          "data-selenium-test": "toggle-advanced-filters-panel-button",
          to: `/view/${viewId}/filters${queryParamsString}`,
          use: "transparent",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "filter"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "tasks-table.filters.filterButtonLabel"
          })]
        })
      }), hasNonDefaultFilters && /*#__PURE__*/_jsx(Section, {
        marginInlineStart: "300",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: handleResetFilters,
          "data-test-id": "filter-reset-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "filterBar.reset"
          })
        })
      })]
    }),
    endSlot: endSlot
  });
}